import { render, staticRenderFns } from "./ziyuanBgdg.vue?vue&type=template&id=15f3bb4d&"
import script from "./ziyuanBgdg.vue?vue&type=script&lang=js&"
export * from "./ziyuanBgdg.vue?vue&type=script&lang=js&"
import style0 from "./ziyuanBgdg.vue?vue&type=style&index=0&id=15f3bb4d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports